import { useEffect } from "react";

const PostActivity = (props) => {

    useEffect(() => {
            props.setNext(true);
    }, []);

    return(
        <>
            <div className="" style={{padding:'4rem'}} dangerouslySetInnerHTML={{__html: props.content}}>
            </div>
        </>
    );
}

export default PostActivity;